export const state = {
  afterState: {},
  beforeState: {},
  photoName: "sample.jpg",
  style: {},
};
